import {useCallback, useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router';

import {BasicRetailerT} from '@/lib/types/user.types';

import {useAuth} from '@/providers/components/authProvider';

import {SearchAndSelectComponent} from '@/components';

import CreateRetailOrderForm from './components/createRetailOrderForm';
import {CreateRetailOrderProvider} from './providers/createRetailOrderProvider';

function CreateRetailOrderPage() {
  const navigate = useNavigate();
  const {retailerId} = useParams();
  const {
    userAccounts: {retailers},
  } = useAuth();

  const [searchModalVisible, setSearchModalVisible] = useState(false);
  const selectedRetailer = retailers?.find(r => r.retailer_id === Number(retailerId));

  useEffect(() => {
    if (!retailerId) {
      if (retailers && retailers.length === 1) {
        // Redirect to the same page with retailer ID if there's only one
        navigate(`/retailer/orders/${retailers[0].retailer_id}/new`);
      } else {
        setSearchModalVisible(true);
      }
    }
  }, [retailers, navigate, retailerId]);

  const handleRetailerSelect = useCallback(
    (retailer: BasicRetailerT) => {
      navigate(`/retailer/orders/${retailer.retailer_id}/new`);
      setSearchModalVisible(false);
    },
    [navigate]
  );

  // If no retailerId and no retailers, show error
  if (!selectedRetailer && (!retailers || retailers.length === 0)) {
    return <div>No retailers found</div>;
  }

  return (
    <>
      {selectedRetailer ? (
        <CreateRetailOrderProvider retailerId={selectedRetailer.retailer_id}>
          <CreateRetailOrderForm />
        </CreateRetailOrderProvider>
      ) : (
        <SearchAndSelectComponent<BasicRetailerT>
          title="Select a Retailer"
          isVisible={searchModalVisible}
          onClose={() => navigate('/retailer/orders')}
          overrideClose={true}
          onSelect={handleRetailerSelect}
          onSearch={() => null}
          results={retailers || []}
          mapStructure={{
            displayFields: [{title: 'Retailer Name', field: 'retailer_name'}],
            valueField: 'retailer_id',
          }}
        />
      )}
    </>
  );
}

export default CreateRetailOrderPage;
